import {
    Box, Grid, Button, IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography, Stack, TextField, FormControlLabel, Checkbox, InputAdornment, Divider, Autocomplete, Chips, Chip
} from "@mui/material";
import CustomCard from "../../../components/UIComponents/CustomCard";
import TitleCard from "../../../components/TIttleCard";
import HeaderComponent from "../../../components/Header";
import CustomTypography from "../../../components/UIComponents/CustomTypography";
import StyledTextField from "../../../components/UIComponents/StyledTextField";
import StyledAutocomplete from "../../../components/UIComponents/StyledAutocomplete";
import { Add, ArrowForward, ChatBubbleOutline, Delete, Edit, Save } from "@mui/icons-material";
import theme from "../../../assets/theme";
import CustomButton from "../../../components/Buttons";
import { useContext, useEffect, useState } from "react";
import { estimatetariff, getGuestCustomer, getItemTaxTemplateDetails, getReportData, getReservationDetails, getUnallocatedAmount, saveDocs } from "../../../service/network";
import { useLoading } from "../../../context/loading.context";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/auth.context";
import moment from "moment";
import { useNotification } from "../../../context/notification.context";
import PaymentDetails from "../../Reservation/Components/PaymentDetails";
import PersonIcon from '@mui/icons-material/Person';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import InfoIcon from '@mui/icons-material/Info';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import UpdateIcon from '@mui/icons-material/Update';
import { Collapse } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
    fetchStateList,
    fetchCountryList,
    getCustomerDetails,
    updateCustomer,
    updateAddress,
    updateContact,
    getAddressDetails
} from "../../../service/network"; // Update the path as needed

const initialAvailedServices = [
    { id: 1, item: "Room Charge", total: "₹ 1234" },
    { id: 2, item: "Laundry", total: "₹ 1234" },
    { id: 3, item: "Cab", total: "₹ 1234" },
    { id: 4, item: "Breakfast", total: "₹ 1234" },
    { id: 5, item: "Dinner", total: "₹ 1234" },
];

// Remove the conditional initialization and always start with empty array
// With this conditional initialization:

// Then in your component:
const AddPayment_Invoice = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [availedServices, setAvailedServices] = useState(initialAvailedServices);

    const initialInvoiceItems = (netAmount) => {
    if (netAmount === 0) {
        return [
            { id: 1, item: "Room Tariff", qty: 1, rate: "", tax: null, amount: "1", isRoomTariff: true }
        ];
    }
    return [];
};

    const [invoiceItems, setInvoiceItems] = useState(initialInvoiceItems);
    const [taxes, setTaxes] = useState([]);
    const [summary, setSummary] = useState([]);
    const [selCateg, setSelCateg] = useState(null);
    const [categs, setCategs] = useState([]);
    const [itemtaxconfigs, setItmTaxConfg] = useState({});
    const [taxsplit, setTaxSplit] = useState({});
    const [customer, setCustomer] = useState("Customer");
    const { showLoader, hideLoader } = useLoading();
    const { details } = location.state || {};
    const { selLocation } = useContext(AuthContext);
    const { showNotification } = useNotification();
    const [unalloc, setUnalloc] = useState(0);
    const [resdetails, setReservationDetails] = useState(null);
    const [estimates, setEstimates] = useState(null);
    const [custOptions, setCustOptions] = useState(["Customer"]);
    const [unallocated, setUnallocated] = useState(0);
    const [isExpanded, setIsExpanded] = useState(true); // Start expanded by default
    //


    // New state variables for customer details
    const [customerDetails, setCustomerDetails] = useState(null);
    const [customerAddresses, setCustomerAddresses] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [editedCustomer, setEditedCustomer] = useState({});
    const [editedAddress, setEditedAddress] = useState({});

    // Fetch customer details when customer changes
    useEffect(() => {
        if (customer && customer !== "Customer") {
            fetchCustomerDetails(customer);
        } else {
            setCustomerDetails(null);
            setCustomerAddresses([]);
            setSelectedAddress(null);
        }
    }, [customer]);

    // Fetch countries list
    useEffect(() => {
        fetchCountries();
    }, []);

    const fetchCountries = async () => {
        try {
            const params = {
                doctype: 'Country',
                fields: JSON.stringify(["name"]),
                filters: JSON.stringify({}),
            };
            const response = await fetchCountryList(params);
            if (response.data?.message) {
                const countryList = response.data.message.values?.map(item => item[0]) || [];
                setCountries(countryList);
            }
        } catch (error) {
            console.error("Error fetching countries:", error);
        }
    };

    const fetchStatesForCountry = async (country) => {
        if (!country) return;
        try {
            const response = await fetchStateList(country);
            if (response.data?.data?.states) {
                const stateList = response.data.data.states.map(state => state.name);
                setStates(stateList);
            }
        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };

    // Replace the existing customer details fetch with this enhanced version
    const fetchCustomerDetails = async (customerName) => {
        try {
            showLoader();
            const response = await getCustomerDetails(customerName);

            const customerData = response.data?.docs?.[0];

            if (customerData) {
                setCustomerDetails(customerData);

                // Enhanced customer data with fallbacks
                const enhancedCustomerData = {
                    ...customerData,
                    // Ensure critical fields have fallbacks
                    customer_name: customerData.customer_name || 'Unnamed Customer',
                    customer_type: customerData.customer_type || 'Individual',
                    tax_id: customerData.tax_id || 'Not Provided',
                    // Enhanced contact information
                    primary_email: customerData.email_id ||
                        customerData.__onload?.contact_list?.[0]?.email_id ||
                        'No email provided',
                    primary_phone: customerData.mobile_no ||
                        customerData.__onload?.contact_list?.[0]?.mobile_no ||
                        'No phone provided',
                    // Additional metadata
                    creation_date: customerData.creation ?
                        moment(customerData.creation).format('MMM DD, YYYY') : 'Unknown',
                    status: customerData.disabled ? 'Inactive' : 'Active'
                };

                setCustomerDetails(enhancedCustomerData);

                // Set edited customer for form
                setEditedCustomer({
                    customer_name: enhancedCustomerData.customer_name,
                    customer_type: enhancedCustomerData.customer_type,
                    tax_id: enhancedCustomerData.tax_id,
                    email_id: enhancedCustomerData.primary_email,
                    mobile_no: enhancedCustomerData.primary_phone
                });

                // Enhanced address handling
                const addresses = customerData.__onload?.addr_list || [];
                setCustomerAddresses(addresses);

                if (addresses.length > 0) {
                    const primaryAddress =
                        addresses.find(addr => addr.is_primary_address === 1) ||
                        addresses.find(addr => addr.is_shipping_address === 1) ||
                        addresses[0];

                    setSelectedAddress(primaryAddress);
                    setEditedAddress({
                        address_line1: primaryAddress.address_line1 || '',
                        address_line2: primaryAddress.address_line2 || '',
                        city: primaryAddress.city || '',
                        state: primaryAddress.state || '',
                        country: primaryAddress.country || '',
                        pincode: primaryAddress.pincode || '',
                        address_title: primaryAddress.address_title || 'Primary Address',
                        is_primary_address: primaryAddress.is_primary_address || false,
                        is_shipping_address: primaryAddress.is_shipping_address || false
                    });

                    if (primaryAddress.country) {
                        fetchStatesForCountry(primaryAddress.country);
                    }
                } else {
                    // Create default address structure if none exists
                    setSelectedAddress(null);
                    setEditedAddress({
                        address_line1: '',
                        address_line2: '',
                        city: '',
                        state: '',
                        country: '',
                        pincode: '',
                        address_title: 'Billing Address',
                        is_primary_address: true,
                        is_shipping_address: true
                    });
                }
            }
        } catch (error) {
            console.error("Error fetching customer details:", error);
            showNotification('error', 'Error', 'Failed to fetch customer details');

            // Set default customer details on error
            setCustomerDetails({
                customer_name: customerName,
                customer_type: 'Individual',
                status: 'Active',
                primary_email: 'Not available',
                primary_phone: 'Not available'
            });
        } finally {
            hideLoader();
        }
    };
    const fetchAddressDetails = async (addressId) => {
        try {
            const response = await getAddressDetails(addressId);
            const addressData = response.data?.data;

            console.log("Address API Response:", addressData);

            if (addressData) {
                // Since we're fetching a single address by ID, wrap it in an array
                const addresses = [addressData];
                setCustomerAddresses(addresses);
                setSelectedAddress(addressData);
                setEditedAddress({
                    address_line1: addressData.address_line1 || '',
                    address_line2: addressData.address_line2 || '',
                    city: addressData.city || '',
                    state: addressData.state || '',
                    country: addressData.country || '',
                    pincode: addressData.pincode || '',
                    address_title: addressData.address_title || 'Billing Address',
                    is_primary_address: addressData.is_primary_address || true,
                    is_shipping_address: addressData.is_shipping_address || true
                });

                if (addressData.country) {
                    fetchStatesForCountry(addressData.country);
                }
            }
        } catch (error) {
            console.error("Error fetching address details:", error);
            showNotification('error', 'Error', 'Failed to fetch address details');
        }
    };
    const handleAddressSelect = (address) => {
        setSelectedAddress(address);
        setEditedAddress({
            address_line1: address.address_line1,
            address_line2: address.address_line2,
            city: address.city,
            state: address.state,
            country: address.country,
            pincode: address.pincode,
            address_title: address.address_title,
            is_primary_address: address.is_primary_address,
            is_shipping_address: address.is_shipping_address
        });

        // Fetch states for the selected country
        if (address.country) {
            fetchStatesForCountry(address.country);
        }
    };

    const handleEditToggle = () => {
        if (isEditing) {
            // Save changes
            saveCustomerChanges();
        } else {
            // Start editing
            setIsEditing(true);
        }
    };

    const saveCustomerChanges = async () => {
        try {
            showLoader();

            // Update customer details
            if (customerDetails) {
                await updateCustomer(customerDetails.name, editedCustomer);
            }

            // Update or create address details
            if (selectedAddress) {
                // Update existing address
                await updateAddress(selectedAddress.name, editedAddress);
            } else if (editedAddress.address_line1) {
                // Create new address if we have address line 1
                const newAddressPayload = {
                    ...editedAddress,
                    links: [{
                        link_doctype: 'Customer',
                        link_name: customerDetails.name,
                        link_title: customerDetails.customer_name
                    }]
                };
                // You'll need to implement createAddress function
                // await createAddress(newAddressPayload);
            }

            setIsEditing(false);
            showNotification('success', 'Success', 'Customer details updated successfully');

            // Refresh customer details
            if (customer && customer !== "Customer") {
                await fetchCustomerDetails(customer);
            }
        } catch (error) {
            console.error("Error updating customer details:", error);
            showNotification('error', 'Error', 'Failed to update customer details');
        } finally {
            hideLoader();
        }
    };

    const handleCustomerFieldChange = (field, value) => {
        setEditedCustomer(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleAddressFieldChange = (field, value) => {
        setEditedAddress(prev => ({
            ...prev,
            [field]: value
        }));

        // If country changes, fetch states for that country
        if (field === 'country') {
            fetchStatesForCountry(value);
        }
    };

    const handleCancelEdit = () => {
        // Reset edited data to original values
        if (customerDetails) {
            setEditedCustomer({
                customer_name: customerDetails.customer_name,
                customer_type: customerDetails.customer_type,
                tax_id: customerDetails.tax_id,
                email_id: customerDetails.email_id,
                mobile_no: customerDetails.mobile_no
            });
        }

        if (selectedAddress) {
            setEditedAddress({
                address_line1: selectedAddress.address_line1,
                address_line2: selectedAddress.address_line2,
                city: selectedAddress.city,
                state: selectedAddress.state,
                country: selectedAddress.country,
                pincode: selectedAddress.pincode,
                address_title: selectedAddress.address_title,
                is_primary_address: selectedAddress.is_primary_address,
                is_shipping_address: selectedAddress.is_shipping_address
            });

            // Fetch states for the original country
            if (selectedAddress.country) {
                fetchStatesForCountry(selectedAddress.country);
            }
        }

        setIsEditing(false);
    };

    const addNewAddress = () => {
        const newAddress = {
            address_line1: '',
            address_line2: '',
            city: '',
            state: '',
            country: '',
            pincode: '',
            address_title: `Address ${customerAddresses.length + 1}`,
            is_primary_address: false,
            is_shipping_address: false
        };

        setCustomerAddresses(prev => [...prev, newAddress]);
        setSelectedAddress(newAddress);
        setEditedAddress(newAddress);
        setIsEditing(true);
    };

    // Rest of your existing useEffect hooks and functions remain the same...
    useEffect(() => {
        if (resdetails) {
            if (resdetails.corporate) {
                setCustOptions(["Customer", resdetails.corporate]);
            }
            estimatetariff({ reservation_id: resdetails.name }).then((resp) => {
                setEstimates(resp.data.message);
            }).catch((err) => {
                console.log(err);
            })
        }
    }, [resdetails, setEstimates]);

    useEffect(() => {
        console.log("Details from the Path route", details);
    }, [details])

    const getUnallocPayments = () => {
        getUnallocatedAmount({ reservation: details?.reservation_id }).then((resp) => {
            setUnalloc(resp.data.message.unallocated);
        }).catch((err) => {
            console.log(err);
        })
    }

    useEffect(() => {
        if (details?.reservation_id) {
            getReservationDetails(details?.reservation_id).then((resp) => {
                const reservationData = resp.data.data;
                setReservationDetails(reservationData);

                // Only add Room Tariff when net_amount === 0
                const netAmount = reservationData?.net_amount;
                if (netAmount === 0) {
                    setInvoiceItems([
                        {
                            id: 1,
                            item: "Room Tariff",
                            qty: 1,
                            rate: "",
                            tax: null,
                            amount: "1",
                            isRoomTariff: true
                        }
                    ]);
                } else {
                    // Start with empty array - user can add items manually
                    setInvoiceItems([]);
                }

                console.log(resp.data);
            }).catch((err) => {
                console.log(err);
            })
        }
    }, [details]);

    useEffect(() => {
        getTaxCategoryList();
        getUnallocPayments();
    }, []);

    useEffect(() => {
        if (selCateg) {
            getItemTaxCategoryMappings(selCateg);
            let temp = [...invoiceItems];
            for (let itm in temp) {
                temp[itm].tax = null;
                temp[itm]["tax_template"] = null;
            }
            setItmTaxConfg({});
        }
    }, [selCateg])

    const getTaxCategoryList = () => {
        let params = {
            doctype: 'Tax Category',
            fields: JSON.stringify(["name"]),
            filters: JSON.stringify({}),
        }
        getReportData(params).then((resp) => {
            if (resp.data?.message && (!Array.isArray(resp.data?.message))) {
                let tm = [];
                for (let ctg of resp.data?.message?.values) {
                    tm.push(ctg[0]);
                }
                setCategs(tm);
            } else {
                setEntries([]);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const getItemTaxCategoryMappings = (category) => {
        let params = {
            doctype: 'ItemTaxMapping',
            fields: JSON.stringify(["item_tax_template", "rate"]),
            filters: JSON.stringify({ tax_category: category }),
        }
        getReportData(params).then((resp) => {
            if (resp.data?.message && (!Array.isArray(resp.data?.message))) {
                let tp = [];
                for (let txm of resp.data?.message?.values) {
                    tp.push({
                        label: `${txm[1]}%`,
                        tax: txm[1],
                        template: txm[0]
                    })
                }
                setTaxes(tp);
            } else {
                setTaxes([]);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const handleAddServiceToInvoice = (service) => {
        const exists = invoiceItems.some(item => item.id === service.name);
        if (exists) return;

        const newItem = {
            id: service.name,
            item: service.service_name,
            qty: 1,
            rate: service.amount,
            tax: null,
            amount: service.amount
        };

        setInvoiceItems([...invoiceItems, newItem]);
    };
    const handleAddNewRow = () => {
        // Check if we can add new items (only when net_amount === 0 OR we already have items)
      

        const newItem = {
            id: Date.now(),
            item: null,
            qty: 1,
            rate: 1,
            tax: null,
            amount: 1,
            description: ""
        };
        setInvoiceItems([...invoiceItems, newItem]);
    };
    const handleRemoveRow = (index) => {
        if (invoiceItems.length > 1) {
            const updatedRows = invoiceItems.filter((_, i) => i !== index);
            setInvoiceItems(updatedRows);
        }
    }

    const handleItemChange = async (index, key, value) => {
        let dt = invoiceItems[index];
        dt[key] = value;
        console.log(dt);
        if (!["name", "description"].includes(key)) {
            let amount = parseFloat(dt.qty) * parseFloat(dt.rate);
            dt['amount'] = parseFloat(amount.toFixed(2));
        }
        if ((key === "tax") && (value)) {
            if (!itemtaxconfigs[value.template]) {
                try {
                    let dts = await getItemTaxTemplateDetails(value.template);
                    let temp = { ...itemtaxconfigs };
                    temp[value.template] = dts.data.data;
                    setItmTaxConfg({ ...temp });
                } catch (err) {
                    dt['tax'] = null;
                }
            }
        }
        let res = [...invoiceItems]
        res[index] = dt;
        setInvoiceItems(res);
    }

    const getSummary = () => {
        let tax_comp = {};
        let temp = {
            subtotal: 0,
            tax: 0,
            discount: parseFloat(summary.discount ?? 0),
            total: 0
        };
        for (let itm of invoiceItems) {
            let itm_s = (parseFloat(itm.qty) * parseFloat(itm.rate));
            temp.subtotal += itm_s;
            if (itm.tax) {
                let it_tax = 0;
                if (itemtaxconfigs[itm.tax.template]) {
                    for (let txs of itemtaxconfigs[itm.tax.template].taxes) {
                        let nt = itm_s * (txs.tax_rate / 100)
                        it_tax += nt;
                        if (tax_comp[txs.tax_type]) {
                            tax_comp[txs.tax_type] += nt;
                        } else {
                            tax_comp[txs.tax_type] = nt;
                        }
                    }
                }
                temp.tax += it_tax;
            }
        }
        temp.total = temp.subtotal + temp.tax - temp.discount;
        setTaxSplit(tax_comp);
        setSummary(temp);
    }

    useEffect(() => {
        getSummary();
    }, [summary.discount, invoiceItems, selCateg]);

    const createSaleInvoice = async () => {
        try {
            showLoader();
            let account_params = {
                doctype: 'Account',
                fields: JSON.stringify(["name"]),
                filters: [["company", "=", selLocation[0]], ["name", "like", "%ser%"], ["root_type", "=", "Income"]],
            };
            let acc_params = await getReportData(account_params);
            console.log(acc_params.data.message);

            let cst = null;
            if (customer === "Customer") {
                let cdt = await getGuestCustomer({
                    reservation: details.reservation_id
                });
                cst = cdt.data.message.customer;
            } else {
                cst = customer;
            }

            // Get customer tax details and address for the invoice
            let taxId = '';
            let billingAddress = '';
            let customerAddress = '';

            if (customerDetails) {
                // Use tax_id from customer details
                taxId = customerDetails.tax_id || editedCustomer.tax_id || '';

                // Use the selected address for billing address
                if (selectedAddress) {
                    // Format address according to Frappe standards
                    const addressLines = [];
                    if (selectedAddress.address_line1) addressLines.push(selectedAddress.address_line1);
                    if (selectedAddress.address_line2) addressLines.push(selectedAddress.address_line2);
                    if (selectedAddress.city) addressLines.push(selectedAddress.city);
                    if (selectedAddress.state) addressLines.push(selectedAddress.state);
                    if (selectedAddress.country) addressLines.push(selectedAddress.country);
                    if (selectedAddress.pincode) addressLines.push(selectedAddress.pincode);

                    billingAddress = addressLines.join(', ');
                    customerAddress = selectedAddress.name; // Address document name
                }
            }

            const payload = {
                doctype: "Sales Invoice",
                company: selLocation[0],
                reservation: details.reservation_id,
                customer: cst,
                items: [],
                taxes: [],
                discount_amount: parseFloat(summary.discount ?? 0) || 0,
                posting_date: moment().format("YYYY-MM-DD"),
                posting_time: moment().format("HH:mm:ss"),
                // Add tax_id and address information
                tax_id: taxId,
                customer_address: customerAddress,
                address_display: billingAddress,
                // Additional Frappe standard fields for billing
                billing_address: billingAddress,
                customer_tax_id: taxId,
            };

            let tax_types = [];
            for (let itm of invoiceItems) {
                if (parseFloat(itm.qty) > 0) {
                    payload.items.push({
                        item_name: itm.item,
                        qty: parseFloat(itm.qty),
                        rate: parseFloat(itm.rate),
                        amount: parseFloat(itm.qty) * parseFloat(itm.rate),
                        item_tax_template: itm.tax ? itm.tax.template : null,
                        description: itm.description,
                        income_account: acc_params.data.message.values[0][0]
                    });
                    if ((itm.tax) && (itm.tax.template)) {
                        if (itemtaxconfigs[itm.tax.template]) {
                            for (let ttm of itemtaxconfigs[itm.tax.template].taxes) {
                                if (!tax_types.includes(ttm.tax_type)) {
                                    tax_types.push(ttm.tax_type);
                                }
                            }
                        }
                    }
                }
            }

            for (let taxType of tax_types) {
                payload.taxes.push({
                    charge_type: "On Net Total",
                    account_head: taxType,
                    description: `Taxes on account ${taxType}`
                });
            }

            // Add tax breakdown if available
            if (Object.keys(taxsplit).length > 0) {
                payload.tax_breakup = Object.entries(taxsplit).map(([tax_type, amount]) => ({
                    tax_type: tax_type,
                    tax_amount: amount
                }));
            }

            console.log("Final payload with tax and address info:", payload);

            if (payload.items.length > 0) {
                let sales_invoice = await saveDocs({
                    doc: JSON.stringify(payload),
                    action: "Submit"
                });
                showNotification('success', 'Success', 'Invoice created successfully');
                navigate(-1);
            }
            else {
                showNotification('error', 'Failed', 'Add at least 1 Valid item');
            }
        } catch (err) {
            console.log(err);
            showNotification('error', 'Failed', 'Failed to add invoice.');
        } finally {
            hideLoader();
        }
    }

    // Update this useEffect to handle the net_amount condition
    useEffect(() => {
        if (estimates?.estimate?.room_charge && invoiceItems.length > 0) {
            console.log("Updating room tariff with estimates:", estimates.estimate);

            const updatedItems = invoiceItems.map(item => {
                if (item.isRoomTariff) {
                    // Use the room_charge directly as the rate
                    const roomCharge = parseFloat(estimates.estimate.room_charge);
                    return {
                        ...item,
                        rate: roomCharge.toString(),
                        amount: roomCharge.toString()
                    };
                }
                return item;
            });

            console.log("Updated invoice items:", updatedItems);
            setInvoiceItems(updatedItems);
        }
    }, [estimates]);
    return (
        <Box sx={{ width: "100%", p: 2 }}>
            <HeaderComponent title="Payment & Invoice" />
            <TitleCard
                reservationId={details?.reservation_id}
                checkIn={moment(details?.arrival_date).format("MMM DD, YYYY")}
                checkOut={moment(details?.departure_date).format("MMM DD, YYYY")}
                status={''}
            />

            <CustomCard
                sx={{
                    width: "100%",
                    minHeight: 800,
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                    py: 4,
                }}
            >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <CustomTypography
                        variant="SubTitleBold"
                        gutterBottom
                        color="primary.main"
                        sx={{ mb: 3 }}
                    >
                        Add Invoice
                    </CustomTypography>
                </Box>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 12, xl: 3 }}>
                        <Grid container>
                            <Grid size={12} mt={1} mb={1}>
                                <PaymentDetails details={resdetails} tariff={estimates} disableButton unallocatedAmount={unalloc} />
                            </Grid>
                            <Grid size={12}>
                                <Box
                                    sx={{
                                        border: '1px solid #CFCFCF',
                                        borderRadius: theme.borderRadius.large,
                                        p: 2,
                                        backgroundColor: 'light.main',
                                        height: '100%',
                                    }}
                                >
                                    <CustomTypography variant="HeadingLarge" gutterBottom>
                                        Availed Services
                                    </CustomTypography>
                                    <Paper
                                        elevation={0}
                                        sx={{
                                            borderRadius: 3,
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <Table sx={{ borderCollapse: 'separate', borderSpacing: 0, mt: 1 }}>
                                            <TableHead>
                                                <TableRow
                                                    sx={{
                                                        backgroundColor: 'secondary.main',
                                                        '& th': {
                                                            fontWeight: 'bold',
                                                            color: 'primary.main',
                                                            py: 0.75,
                                                            border: 'none',
                                                        },
                                                        '& th:first-of-type': {
                                                            borderTopLeftRadius: 12,
                                                            borderBottomLeftRadius: 12,
                                                        },
                                                        '& th:last-of-type': {
                                                            borderTopRightRadius: 12,
                                                            borderBottomRightRadius: 12,
                                                        },
                                                    }}
                                                >
                                                    <TableCell>Item</TableCell>
                                                    <TableCell align="right">Total</TableCell>
                                                    <TableCell align="right">Action</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody
                                                sx={{
                                                    backgroundColor: 'light.main',
                                                    '& td': {
                                                        py: 0.75,
                                                        border: 'none',
                                                    },
                                                }}
                                            >
                                                {resdetails?.addon_services.map((service, index) => (
                                                    <TableRow
                                                        key={index}
                                                        sx={{
                                                            '& td': {
                                                                py: 1,
                                                                borderBottom: index !== availedServices.length - 1 ? '1px solid #ddd' : 0,
                                                            },
                                                        }}
                                                    >
                                                        <TableCell>{service.service_name}</TableCell>
                                                        <TableCell align="right">{service.amount}</TableCell>
                                                        <TableCell align="right">
                                                            <IconButton
                                                                size="small"
                                                                sx={{
                                                                    backgroundColor: 'green.main',
                                                                    borderRadius: '50%',
                                                                    color: 'light.main',
                                                                    '&:hover': {
                                                                        backgroundColor: 'green.dark',
                                                                    },
                                                                }}
                                                                onClick={() => handleAddServiceToInvoice(service)}
                                                            >
                                                                <ArrowForward fontSize="small" />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Paper>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={{ xs: 12, md: 12, xl: 9 }}>
                        <Grid container spacing={2}>
                            <Grid size={6}>
                                <CustomTypography
                                    variant="bodyText1"
                                    display="block"
                                    gutterBottom
                                    color="dark.main"
                                >
                                    Invoice To
                                </CustomTypography>
                                <Autocomplete
                                    sx={{ minWidth: 300 }}
                                    options={custOptions}
                                    value={customer}
                                    getOptionDisabled={(option) => option.label}
                                    onChange={(ele, val) => {
                                        setCustomer(val);
                                    }}
                                    slotProps={{
                                        popper: {
                                            modifiers: [
                                                {
                                                    name: 'offset',
                                                    options: {
                                                        offset: [0, 8],
                                                    },
                                                },
                                            ],
                                        },
                                        paper: {
                                            sx: {
                                                '& .MuiAutocomplete-option:hover': {
                                                    backgroundColor: '#E1EFFF!important',
                                                },
                                            },
                                        },
                                    }}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                />
                            </Grid>
                            <Grid size={6}>
                                <CustomTypography
                                    variant="bodyText1"
                                    display="block"
                                    gutterBottom
                                    color="dark.main"
                                >
                                    Tax Category
                                </CustomTypography>
                                <Autocomplete
                                    sx={{ minWidth: 300 }}
                                    options={categs}
                                    onChange={(ele, val) => {
                                        setSelCateg(val);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            sx={{ borderRadius: 10 }}
                                        />
                                    )}
                                    componentsProps={{
                                        paper: {
                                            sx: {
                                                '& .MuiAutocomplete-option:hover': {
                                                    backgroundColor: '#E1EFFF!important',
                                                },
                                            },
                                        },
                                    }}
                                />
                            </Grid>

                            {/* Customer Details Card */}
                            {customerDetails && (
                                <Grid size={12}>
                                    <Paper
                                        elevation={0}
                                        sx={{
                                            border: '1px solid #e0e0e0',
                                            borderRadius: 3,
                                            p: 0,
                                            mt: 2,
                                            overflow: 'hidden',
                                            background: 'linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%)'
                                        }}
                                    >
                                        {/* Header Section - Always Visible */}
                                        <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            p={3}
                                            sx={{
                                                cursor: 'pointer',
                                                backgroundColor: 'white',
                                                borderBottom: isExpanded ? '1px solid #e0e0e0' : 'none',
                                                transition: 'all 0.3s ease',
                                                '&:hover': {
                                                    backgroundColor: '#fafbff'
                                                }
                                            }}
                                            onClick={() => setIsExpanded(!isExpanded)}
                                        >
                                            <Box display="flex" alignItems="center" gap={2}>
                                                <Box
                                                    sx={{
                                                        width: 40,
                                                        height: 40,
                                                        borderRadius: '50%',
                                                        backgroundColor: 'primary.main',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        color: 'white',
                                                        transition: 'transform 0.3s ease',
                                                        transform: isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)'
                                                    }}
                                                >
                                                    <PersonIcon />
                                                </Box>
                                                <Box>
                                                    <CustomTypography variant="HeadingLarge" sx={{ mb: 0.5 }}>
                                                        Customer Information
                                                    </CustomTypography>
                                                    <CustomTypography variant="bodyText2" color="text.secondary">
                                                        {isExpanded ? 'Click to collapse' : 'Click to expand'} • {customerDetails.customer_name}
                                                    </CustomTypography>
                                                </Box>
                                            </Box>

                                            <Box display="flex" alignItems="center" gap={1}>
                                                <Box display="flex" gap={1} onClick={(e) => e.stopPropagation()}>
                                                    {isEditing && (
                                                        <Button
                                                            variant="outlined"
                                                            onClick={handleCancelEdit}
                                                            startIcon={<CancelIcon />}
                                                            size="small"
                                                            sx={{
                                                                borderRadius: 2,
                                                                borderColor: 'error.main',
                                                                color: 'error.main',
                                                                '&:hover': {
                                                                    borderColor: 'error.dark',
                                                                    backgroundColor: 'error.light'
                                                                }
                                                            }}
                                                        >
                                                            Discard
                                                        </Button>
                                                    )}
                                                    <Button
                                                        variant="contained"
                                                        startIcon={isEditing ? <SaveIcon /> : <EditIcon />}
                                                        onClick={handleEditToggle}
                                                        size="small"
                                                        sx={{
                                                            borderRadius: 2,
                                                            px: 3,
                                                            backgroundColor: isEditing ? 'success.main' : 'primary.main',
                                                            '&:hover': {
                                                                backgroundColor: isEditing ? 'success.dark' : 'primary.dark'
                                                            }
                                                        }}
                                                    >
                                                        {isEditing ? 'Save' : 'Edit'}
                                                    </Button>
                                                </Box>

                                                <Box
                                                    sx={{
                                                        transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                                        transition: 'transform 0.3s ease',
                                                        color: 'primary.main',
                                                        ml: 2
                                                    }}
                                                >
                                                    <KeyboardArrowDownIcon />
                                                </Box>
                                            </Box>
                                        </Box>

                                        {/* Expandable Content */}
                                        <Collapse in={isExpanded}>
                                            <Box p={3}>
                                                {/* Customer Information Grid */}
                                                <Grid container spacing={3}>
                                                    {/* Basic Information Column */}
                                                    <Grid item xs={12} md={6}>
                                                        <Box
                                                            sx={{
                                                                p: 2.5,
                                                                borderRadius: 2,
                                                                backgroundColor: 'white',
                                                                border: '1px solid',
                                                                borderColor: 'grey.200',
                                                                height: '100%',
                                                                transition: 'all 0.3s ease',
                                                                '&:hover': {
                                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                                                                }
                                                            }}
                                                        >
                                                            <CustomTypography
                                                                variant="subHeading"
                                                                sx={{
                                                                    mb: 2,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 1,
                                                                    color: 'primary.main'
                                                                }}
                                                            >
                                                                <InfoIcon fontSize="small" />
                                                                Basic Information
                                                            </CustomTypography>

                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12}>
                                                                    <CustomTypography variant="bodyText1" gutterBottom sx={{ fontWeight: 600 }}>
                                                                        Customer Name *
                                                                    </CustomTypography>
                                                                    {isEditing ? (
                                                                        <TextField
                                                                            fullWidth
                                                                            value={editedCustomer.customer_name || ''}
                                                                            onChange={(e) => handleCustomerFieldChange('customer_name', e.target.value)}
                                                                            size="small"
                                                                            placeholder="Enter customer name"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    borderRadius: 2,
                                                                                    backgroundColor: '#fafbff'
                                                                                }
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <CustomTypography variant="bodyText2" sx={{
                                                                            p: 1.5,
                                                                            borderRadius: 1,
                                                                            backgroundColor: 'grey.50',
                                                                            minHeight: '40px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            border: '1px solid transparent',
                                                                            transition: 'all 0.2s ease'
                                                                        }}>
                                                                            {customerDetails.customer_name || 'Not provided'}
                                                                        </CustomTypography>
                                                                    )}
                                                                </Grid>

                                                                <Grid item xs={12} sm={6}>
                                                                    <CustomTypography variant="bodyText1" gutterBottom sx={{ fontWeight: 600 }}>
                                                                        GST Number
                                                                    </CustomTypography>
                                                                    {isEditing ? (
                                                                        <TextField
                                                                            fullWidth
                                                                            value={editedCustomer.tax_id || ''}
                                                                            onChange={(e) => handleCustomerFieldChange('tax_id', e.target.value)}
                                                                            size="small"
                                                                            placeholder="GSTIN number"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    borderRadius: 2,
                                                                                    backgroundColor: '#fafbff'
                                                                                }
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <CustomTypography variant="bodyText2" sx={{
                                                                            p: 1.5,
                                                                            borderRadius: 1,
                                                                            backgroundColor: 'grey.50',
                                                                            minHeight: '40px',
                                                                            display: 'flex',
                                                                            alignItems: 'center'
                                                                        }}>
                                                                            {customerDetails.tax_id || 'Not provided'}
                                                                        </CustomTypography>
                                                                    )}
                                                                </Grid>


                                                            </Grid>
                                                        </Box>
                                                    </Grid>

                                                    {/* Contact Information Column */}
                                                    <Grid item xs={12} md={6}>
                                                        <Box
                                                            sx={{
                                                                p: 2.5,
                                                                borderRadius: 2,
                                                                backgroundColor: 'white',
                                                                border: '1px solid',
                                                                borderColor: 'grey.200',
                                                                height: '100%',
                                                                transition: 'all 0.3s ease',
                                                                '&:hover': {
                                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                                                                }
                                                            }}
                                                        >
                                                            <CustomTypography
                                                                variant="subHeading"
                                                                sx={{
                                                                    mb: 2,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 1,
                                                                    color: 'primary.main'
                                                                }}
                                                            >
                                                                <ContactPhoneIcon fontSize="small" />
                                                                Contact Information
                                                            </CustomTypography>

                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12} sm={6}>
                                                                    <CustomTypography variant="bodyText1" gutterBottom sx={{ fontWeight: 600 }}>
                                                                        Email Address *
                                                                    </CustomTypography>
                                                                    {isEditing ? (
                                                                        <TextField
                                                                            fullWidth
                                                                            value={editedCustomer.email_id || ''}
                                                                            onChange={(e) => handleCustomerFieldChange('email_id', e.target.value)}
                                                                            size="small"
                                                                            type="email"
                                                                            placeholder="customer@email.com"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    borderRadius: 2,
                                                                                    backgroundColor: '#fafbff'
                                                                                }
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <Box display="flex" alignItems="center" gap={1} sx={{ p: 1.5, borderRadius: 1, backgroundColor: 'grey.50', minHeight: '40px' }}>
                                                                            <EmailIcon fontSize="small" color="action" />
                                                                            <CustomTypography variant="bodyText2">
                                                                                {customerDetails.email_id || 'Not provided'}
                                                                            </CustomTypography>
                                                                        </Box>
                                                                    )}
                                                                </Grid>

                                                                <Grid item xs={12} sm={6}>
                                                                    <CustomTypography variant="bodyText1" gutterBottom sx={{ fontWeight: 600 }}>
                                                                        Mobile Number *
                                                                    </CustomTypography>
                                                                    {isEditing ? (
                                                                        <TextField
                                                                            fullWidth
                                                                            value={editedCustomer.mobile_no || ''}
                                                                            onChange={(e) => handleCustomerFieldChange('mobile_no', e.target.value)}
                                                                            size="small"
                                                                            placeholder="10-digit mobile number"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    borderRadius: 2,
                                                                                    backgroundColor: '#fafbff'
                                                                                }
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <Box display="flex" alignItems="center" gap={1} sx={{ p: 1.5, borderRadius: 1, backgroundColor: 'grey.50', minHeight: '40px' }}>
                                                                            <PhoneIcon fontSize="small" color="action" />
                                                                            <CustomTypography variant="bodyText2">
                                                                                {customerDetails.mobile_no || 'Not provided'}
                                                                            </CustomTypography>
                                                                        </Box>
                                                                    )}
                                                                </Grid>


                                                            </Grid>
                                                        </Box>
                                                    </Grid>
                                                </Grid>

                                                {/* Address Section */}
                                                <Box mt={3}>
                                                    <Box
                                                        sx={{
                                                            p: 2.5,
                                                            borderRadius: 2,
                                                            backgroundColor: 'white',
                                                            border: '1px solid',
                                                            borderColor: 'grey.200',
                                                            transition: 'all 0.3s ease',
                                                            '&:hover': {
                                                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                                                            }
                                                        }}
                                                    >
                                                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                                            <CustomTypography
                                                                variant="subHeading"
                                                                sx={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 1,
                                                                    color: 'primary.main'
                                                                }}
                                                            >
                                                                <LocationOnIcon fontSize="small" />
                                                                Billing Address
                                                            </CustomTypography>

                                                            {customerAddresses.length > 1 && !isEditing && (
                                                                <Autocomplete
                                                                    size="small"
                                                                    options={customerAddresses}
                                                                    value={selectedAddress}
                                                                    onChange={(e, newValue) => setSelectedAddress(newValue)}
                                                                    getOptionLabel={(option) => option.address_title || 'Untitled Address'}
                                                                    sx={{ width: 200 }}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            label="Select Address"
                                                                            size="small"
                                                                        />
                                                                    )}
                                                                />
                                                            )}
                                                        </Box>

                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12}>
                                                                <CustomTypography variant="bodyText1" gutterBottom sx={{ fontWeight: 600 }}>
                                                                    Address Title
                                                                </CustomTypography>
                                                                {isEditing ? (
                                                                    <TextField
                                                                        fullWidth
                                                                        value={editedAddress.address_title || ''}
                                                                        onChange={(e) => handleAddressFieldChange('address_title', e.target.value)}
                                                                        size="small"
                                                                        placeholder="e.g., Head Office, Billing Address"
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-root': {
                                                                                borderRadius: 2,
                                                                                backgroundColor: '#fafbff'
                                                                            }
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <CustomTypography variant="bodyText2" sx={{ p: 1.5, borderRadius: 1, backgroundColor: 'grey.50', minHeight: '40px', display: 'flex', alignItems: 'center' }}>
                                                                        {selectedAddress?.address_title || 'No title provided'}
                                                                    </CustomTypography>
                                                                )}
                                                            </Grid>

                                                            {/* Address Section - Complete Implementation */}
                                                            <Grid container spacing={2}>
                                                                <Grid size={6}>
                                                                    <CustomTypography variant="bodyText1" gutterBottom sx={{ fontWeight: 600 }}>
                                                                        Address Line 1 *
                                                                    </CustomTypography>
                                                                    {isEditing ? (
                                                                        <TextField
                                                                            fullWidth
                                                                            value={editedAddress.address_line1 || ''}
                                                                            onChange={(e) => handleAddressFieldChange('address_line1', e.target.value)}
                                                                            size="small"
                                                                            placeholder="Street address, P.O. box"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    borderRadius: 2,
                                                                                    backgroundColor: '#fafbff'
                                                                                }
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <CustomTypography variant="bodyText2" sx={{
                                                                            p: 1.5,
                                                                            borderRadius: 1,
                                                                            backgroundColor: 'grey.50',
                                                                            minHeight: '40px',
                                                                            display: 'flex',
                                                                            alignItems: 'center'
                                                                        }}>
                                                                            {selectedAddress?.address_line1 || 'Not provided'}
                                                                        </CustomTypography>
                                                                    )}
                                                                </Grid>

                                                                <Grid size={4}>
                                                                    <CustomTypography variant="bodyText1" gutterBottom sx={{ fontWeight: 600 }}>
                                                                        Address Line 2
                                                                    </CustomTypography>
                                                                    {isEditing ? (
                                                                        <TextField
                                                                            fullWidth
                                                                            value={editedAddress.address_line2 || ''}
                                                                            onChange={(e) => handleAddressFieldChange('address_line2', e.target.value)}
                                                                            size="small"
                                                                            placeholder="Apartment, suite, unit, building, floor"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    borderRadius: 2,
                                                                                    backgroundColor: '#fafbff'
                                                                                }
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <CustomTypography variant="bodyText2" sx={{
                                                                            p: 1.5,
                                                                            borderRadius: 1,
                                                                            backgroundColor: 'grey.50',
                                                                            minHeight: '40px',
                                                                            display: 'flex',
                                                                            alignItems: 'center'
                                                                        }}>
                                                                            {selectedAddress?.address_line2 || 'Not provided'}
                                                                        </CustomTypography>
                                                                    )}
                                                                </Grid>

                                                                <Grid size={3}>
                                                                    <CustomTypography variant="bodyText1" gutterBottom sx={{ fontWeight: 600 }}>
                                                                        City *
                                                                    </CustomTypography>
                                                                    {isEditing ? (
                                                                        <TextField
                                                                            fullWidth
                                                                            value={editedAddress.city || ''}
                                                                            onChange={(e) => handleAddressFieldChange('city', e.target.value)}
                                                                            size="small"
                                                                            placeholder="City name"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    borderRadius: 2,
                                                                                    backgroundColor: '#fafbff'
                                                                                }
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <CustomTypography variant="bodyText2" sx={{
                                                                            p: 1.5,
                                                                            borderRadius: 1,
                                                                            backgroundColor: 'grey.50',
                                                                            minHeight: '40px',
                                                                            display: 'flex',
                                                                            alignItems: 'center'
                                                                        }}>
                                                                            {selectedAddress?.city || 'Not provided'}
                                                                        </CustomTypography>
                                                                    )}
                                                                </Grid>

                                                                <Grid size={3.5}>
                                                                    <CustomTypography variant="bodyText1" gutterBottom sx={{ fontWeight: 600 }}>
                                                                        State *
                                                                    </CustomTypography>
                                                                    {isEditing ? (
                                                                        <Autocomplete
                                                                            freeSolo
                                                                            options={states}
                                                                            value={editedAddress.state || ''}
                                                                            onChange={(e, newValue) => handleAddressFieldChange('state', newValue)}
                                                                            onInputChange={(e, newValue) => handleAddressFieldChange('state', newValue)}
                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                    {...params}
                                                                                    size="small"
                                                                                    placeholder="Select state"
                                                                                    sx={{
                                                                                        '& .MuiOutlinedInput-root': {
                                                                                            borderRadius: 2,
                                                                                            backgroundColor: '#fafbff'
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        />
                                                                    ) : (
                                                                        <CustomTypography variant="bodyText2" sx={{
                                                                            p: 1.5,
                                                                            borderRadius: 1,
                                                                            backgroundColor: 'grey.50',
                                                                            minHeight: '40px',
                                                                            display: 'flex',
                                                                            alignItems: 'center'
                                                                        }}>
                                                                            {selectedAddress?.state || 'Not provided'}
                                                                        </CustomTypography>
                                                                    )}
                                                                </Grid>

                                                                <Grid size={3.5}>
                                                                    <CustomTypography variant="bodyText1" gutterBottom sx={{ fontWeight: 600 }}>
                                                                        Country *
                                                                    </CustomTypography>
                                                                    {isEditing ? (
                                                                        <Autocomplete
                                                                            freeSolo
                                                                            options={countries}
                                                                            value={editedAddress.country || ''}
                                                                            onChange={(e, newValue) => {
                                                                                handleAddressFieldChange('country', newValue);
                                                                                fetchStatesForCountry(newValue);
                                                                            }}
                                                                            onInputChange={(e, newValue) => {
                                                                                handleAddressFieldChange('country', newValue);
                                                                                fetchStatesForCountry(newValue);
                                                                            }}
                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                    {...params}
                                                                                    size="small"
                                                                                    placeholder="Select country"
                                                                                    sx={{
                                                                                        '& .MuiOutlinedInput-root': {
                                                                                            borderRadius: 2,
                                                                                            backgroundColor: '#fafbff'
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        />
                                                                    ) : (
                                                                        <CustomTypography variant="bodyText2" sx={{
                                                                            p: 1.5,
                                                                            borderRadius: 1,
                                                                            backgroundColor: 'grey.50',
                                                                            minHeight: '40px',
                                                                            display: 'flex',
                                                                            alignItems: 'center'
                                                                        }}>
                                                                            {selectedAddress?.country || 'Not provided'}
                                                                        </CustomTypography>
                                                                    )}
                                                                </Grid>

                                                                <Grid item xs={12} sm={6}>
                                                                    <CustomTypography variant="bodyText1" gutterBottom sx={{ fontWeight: 600 }}>
                                                                        ZIP/Postal Code *
                                                                    </CustomTypography>
                                                                    {isEditing ? (
                                                                        <TextField
                                                                            fullWidth
                                                                            value={editedAddress.pincode || ''}
                                                                            onChange={(e) => handleAddressFieldChange('pincode', e.target.value)}
                                                                            size="small"
                                                                            placeholder="Postal code"
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    borderRadius: 2,
                                                                                    backgroundColor: '#fafbff'
                                                                                }
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <CustomTypography variant="bodyText2" sx={{
                                                                            p: 1.5,
                                                                            borderRadius: 1,
                                                                            backgroundColor: 'grey.50',
                                                                            minHeight: '40px',
                                                                            display: 'flex',
                                                                            alignItems: 'center'
                                                                        }}>
                                                                            {selectedAddress?.pincode || 'Not provided'}
                                                                        </CustomTypography>
                                                                    )}
                                                                </Grid>

                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Collapse>
                                    </Paper>
                                </Grid>
                            )}
                            <Grid size={12}>
                                <Paper elevation={0} sx={{ border: '1px solid #e0e0e0', borderRadius: 2, p: 1 }}>
                                    <CustomCard sx={{ p: 0, backgroundColor: "white" }}>
                                        <CustomTypography variant="HeadingLarge" gutterBottom sx={{ mb: 3 }}>
                                            Items to Invoice
                                        </CustomTypography>

                                        {/* Show message only when no items AND net_amount !== 0 */}
                                        {invoiceItems.length === 0 && resdetails?.net_amount !== 0 ? (
                                            <Box sx={{
                                                textAlign: 'center',
                                                py: 4,
                                                color: 'text.secondary',
                                                backgroundColor: 'grey.50',
                                                borderRadius: 2,
                                                mb: 2
                                            }}>
                                                <CustomTypography variant="bodyText1" sx={{ mb: 2 }}>
                                                    No items added yet. You can add services or other items using the button below.
                                                </CustomTypography>
                                               
                                            </Box>
                                        ) : (
                                            /* Show invoice items when they exist */
                                            <>
                                                {invoiceItems.map((row, index) => (
                                                    <Box key={row.id}>
                                                        <Grid container alignItems="center" spacing={2} sx={{
                                                            mb: 2,
                                                            p: 1,
                                                            '&:hover': { backgroundColor: '#fafafa' },
                                                            borderRadius: 1
                                                        }}>
                                                            {/* Item Name */}
                                                            <Grid item xs={4} md={4}>
                                                                <StyledTextField
                                                                    fullWidth
                                                                    disabled={row.isRoomTariff}
                                                                    value={row.item}
                                                                    onChange={(e) => handleItemChange(index, 'item', e.target.value)}
                                                                    placeholder="Item description"
                                                                    label="Item"
                                                                />
                                                            </Grid>

                                                            {/* Quantity */}
                                                            <Grid item xs={2} md={1.5} lg={2}>
                                                                <StyledTextField
                                                                    value={row.qty}
                                                                    onChange={(e) => handleItemChange(index, 'qty', e.target.value)}
                                                                    inputProps={{ style: { textAlign: 'right' } }}
                                                                    label="Quantity"
                                                                />
                                                            </Grid>

                                                            {/* Rate */}
                                                            <Grid item xs={2} md={1.5}>
                                                                <StyledTextField
                                                                    value={row.rate}
                                                                    onChange={(e) => handleItemChange(index, 'rate', e.target.value)}
                                                                    inputProps={{ style: { textAlign: 'right' } }}
                                                                    label="Rate"
                                                                />
                                                            </Grid>

                                                            {/* Tax */}
                                                            <Grid item xs={2} md={1.5}>
                                                                <CustomTypography variant="bodyText1" display="block" gutterBottom color="dark.main">
                                                                    Tax
                                                                </CustomTypography>
                                                                <Autocomplete
                                                                    value={row?.tax ?? null}
                                                                    options={taxes}
                                                                    sx={{ borderRadius: 10, width: 120 }}
                                                                    onChange={(e, val) => handleItemChange(index, 'tax', val)}
                                                                    getOptionLabel={(option) => option.label}
                                                                    renderInput={(params) => (
                                                                        <TextField {...params} sx={{ borderRadius: 10 }} />
                                                                    )}
                                                                    componentsProps={{
                                                                        paper: {
                                                                            sx: {
                                                                                '& .MuiAutocomplete-option:hover': {
                                                                                    backgroundColor: '#E1EFFF!important',
                                                                                },
                                                                            },
                                                                        },
                                                                    }}
                                                                />
                                                            </Grid>

                                                            {/* Amount */}
                                                            <Grid item xs={2} md={1.5}>
                                                                <StyledTextField
                                                                    disabled={true}
                                                                    value={row.amount}
                                                                    onChange={(e) => handleItemChange(index, 'amount', e.target.value)}
                                                                    inputProps={{ style: { textAlign: 'right' } }}
                                                                    label="Amount"
                                                                />
                                                            </Grid>

                                                            {/* Delete Button - Only show for non-RoomTariff items and when multiple items exist */}
                                                            <Grid item xs={0} md={2} sx={{ textAlign: 'center' }}>
                                                                {!row.isRoomTariff && (
                                                                    <IconButton onClick={() => handleRemoveRow(index)} size="small">
                                                                        <Delete fontSize="small" color="error" />
                                                                    </IconButton>
                                                                )}
                                                            </Grid>
                                                        </Grid>

                                                        {/* Description Field */}
                                                        <Grid container sx={{ mt: 1, mb: 2 }}>
                                                            <Grid size={12}>
                                                                <CustomTypography variant="bodyText1" display="block" gutterBottom color="dark.main">
                                                                    Description
                                                                </CustomTypography>
                                                                <TextField
                                                                    fullWidth
                                                                    value={row.description}
                                                                    sx={{
                                                                        borderRadius: theme.borderRadius.large,
                                                                        backgroundColor: theme.palette.lightgray.main
                                                                    }}
                                                                    onChange={(e) => handleItemChange(index, "description", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>

                                                        {/* Divider between items */}
                                                        {index < invoiceItems.length - 1 && <Divider />}
                                                    </Box>
                                                ))}
                                            </>
                                        )}

                                        {/* ALWAYS SHOW ADD ITEM BUTTON */}
                                        <Button
                                            variant="outlined"
                                            startIcon={<Add />}
                                            size="small"
                                            sx={{
                                                borderRadius: 2,
                                                border: `2px dashed ${theme.palette.primary.main}`,
                                                backgroundColor: "transparent",
                                                color: "primary.main",
                                                px: 2,
                                                py: 1,
                                                mt: 1,
                                                '&:hover': {
                                                    border: `2px dashed ${theme.palette.primary.dark}`,
                                                    backgroundColor: 'primary.light',
                                                    color: 'primary.dark'
                                                }
                                            }}
                                            onClick={handleAddNewRow}
                                        >
                                            Add Item
                                        </Button>

                                        {/* Totals Section - Only show when there are invoice items */}
                                        {invoiceItems.length > 0 && (
                                            <Box mt={4} sx={{ borderTop: '1px solid #e0e0e0', pt: 3 }}>
                                                <Grid container spacing={2} justifyContent="flex-end">

                                                    {/* Tax Breakdown */}
                                                    {Object.keys(taxsplit).length > 0 && (
                                                        <Grid item xs={12} md={6}>
                                                            <Box sx={{
                                                                backgroundColor: '#f9f9f9',
                                                                borderRadius: 2,
                                                                p: 2,
                                                                border: '1px solid #eee'
                                                            }}>
                                                                <Stack spacing={1.5}>
                                                                    {Object.keys(taxsplit).map((taxType, index) => (
                                                                        <Box key={taxType} display="flex" justifyContent="space-between" alignItems="center">
                                                                            <Typography variant="subHeading">{taxType}:</Typography>
                                                                            <Typography variant="subHeading" fontWeight="bold">
                                                                                ₹{taxsplit[taxType]?.toFixed(2)}
                                                                            </Typography>
                                                                        </Box>
                                                                    ))}
                                                                    <Divider sx={{ my: 1 }} />
                                                                    <Box display="flex" justifyContent="space-between">
                                                                        <Typography variant="subHeading" fontWeight="bold">Total Tax:</Typography>
                                                                        <Typography variant="subHeading" fontWeight="bold" color="primary">
                                                                            ₹{summary?.tax?.toFixed(2)}
                                                                        </Typography>
                                                                    </Box>
                                                                </Stack>
                                                            </Box>
                                                        </Grid>
                                                    )}

                                                    {/* Summary Totals */}
                                                    <Grid item xs={12} md={6}>
                                                        <Box sx={{
                                                            backgroundColor: '#f9f9f9',
                                                            borderRadius: 2,
                                                            p: 2,
                                                            border: '1px solid #eee'
                                                        }}>
                                                            <Stack spacing={1.5}>
                                                                {/* Subtotal */}
                                                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                                                    <Typography variant="subHeading">Subtotal:</Typography>
                                                                    <Typography variant="subHeading" fontWeight="bold">
                                                                        ₹{summary?.subtotal?.toFixed(2)}
                                                                    </Typography>
                                                                </Box>

                                                                {/* Tax */}
                                                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                                                    <Typography variant="subHeading">Tax:</Typography>
                                                                    <Typography variant="subHeading" fontWeight="bold">
                                                                        ₹{summary?.tax?.toFixed(2)}
                                                                    </Typography>
                                                                </Box>

                                                                {/* Discount */}
                                                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                                                    <Typography variant="subHeading">Discount:</Typography>
                                                                    <TextField
                                                                        variant="outlined"
                                                                        size="small"
                                                                        value={summary.discount || ''}
                                                                        onChange={(e) => setSummary({ ...summary, discount: e.target.value })}
                                                                        sx={{
                                                                            width: 120,
                                                                            '& .MuiOutlinedInput-input': {
                                                                                textAlign: 'right',
                                                                                padding: '8px'
                                                                            }
                                                                        }}
                                                                        InputProps={{
                                                                            startAdornment: (
                                                                                <InputAdornment position="start">₹</InputAdornment>
                                                                            )
                                                                        }}
                                                                    />
                                                                </Box>

                                                                <Divider sx={{ my: 1 }} />

                                                                {/* Total */}
                                                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                                                    <Typography variant="subHeading" fontWeight="bold">Total:</Typography>
                                                                    <Typography variant="subHeading" fontWeight="bold" color="primary">
                                                                        ₹{summary?.total?.toFixed(2)}
                                                                    </Typography>
                                                                </Box>
                                                            </Stack>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        )}
                                    </CustomCard>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Box
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center"
                    mt={3}
                    gap={2}
                >
                    <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mr: 5 }}>
                        <Typography variant="buttonL" minWidth={180}>Un-allocated Amount :</Typography>
                        <Box
                            sx={{
                                backgroundColor: 'green.main',
                                color: 'light.main',
                                px: 2,
                                py: 0.5,
                                borderRadius: 2,
                                fontWeight: 'bold',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            ₹ {unalloc}
                        </Box>
                    </Box>
                    {/* <FormControlLabel
                        control={<Checkbox checked />}
                        label={
                            <Typography variant="subHeading">
                                Mark as Paid
                            </Typography>
                        }
                        sx={{ mr: 1 }}
                    /> */}

                    <CustomButton
                        size="medium"
                        variant="primaryColor"
                        onClick={() => { navigate(-1); }}
                        sx={{
                            borderRadius: 2,
                            border: `2px solid ${theme.palette.primary.main}`,
                            backgroundColor: "light.main",
                            color: "primary.main",
                            width: 120,
                            height: 36,
                        }}
                    >
                        Cancel
                    </CustomButton>

                    <CustomButton
                        size="medium"
                        variant="primaryColor"
                        sx={{
                            borderRadius: 2,
                            backgroundColor: "primary.main",
                            color: "light.main",
                            width: 120,
                            height: 36,
                        }}
                        onClick={() => {
                            createSaleInvoice();
                        }}
                    >
                        Save Invoice
                    </CustomButton>
                </Box>
                {/* </CustomCard> */}
            </CustomCard>
        </Box>
    );
};

export default AddPayment_Invoice;